import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";
import pure from "recompose/pure";

const COLOR = "#2B3940";

const FullscreenIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 14 14" fill="none" >
    <path d="M13 0C13.6 0 14 0.4 14 1V4C14 4.6 13.6 5 13 5C12.4 5 12 4.6 12 4V2H10C9.4 2 9 1.6 9 1C9 0.4 9.4 0 10 0H13ZM0 1C0 0.4 0.4 0 1 0H4C4.6 0 5 0.4 5 1C5 1.6 4.6 2 4 2H2V4C2 4.6 1.6 5 1 5C0.4 5 0 4.6 0 4V1ZM13 9C13.6 9 14 9.4 14 10V13C14 13.6 13.6 14 13 14H10C9.4 14 9 13.6 9 13C9 12.4 9.4 12 10 12H12V10C12 9.4 12.4 9 13 9ZM5 13C5 13.6 4.6 14 4 14H1C0.4 14 0 13.6 0 13V10C0 9.4 0.4 9 1 9C1.6 9 2 9.4 2 10V12H4C4.6 12 5 12.4 5 13Z" fill={COLOR} />
  </SvgIcon>
);
FullscreenIcon.displayName = "FullscreenIcon";
FullscreenIcon.muiName = "SvgIcon";

export default pure(FullscreenIcon);